import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import { useCommonStore } from '@/store/common';
import router from '@/router/index';

// eslint-disable-next-line
import { initVant } from './vant';

import '@/assets/less/global.less';
import '@/assets/less/common.less';

import App from './App.vue';
import GTrack from './common/globalOmega';

const app = createApp(App);
const version = document.querySelector('meta[name="FE-VERSION"]')?.getAttribute('content');

Sentry.init({
  app,
  dsn: 'https://67ea5f9bb4c545b19738745bf4d007eb@sentry-us.didiglobal.com/100',
  // 性能监控开启
  integrations: [new Integrations.BrowserTracing()],
  // 性能监控相关的数值，控制每个事务都有几个百分比的机会被发送到 Sentry，取 0 到 1 之间的数字，0.3 代表30%
  tracesSampleRate: 0.1,
  environment: import.meta.env.MODE,
  // 注意，这里的 release 配置是用来匹配当前项目的 sourcemap 文件的，规则是用项目名 + @ + 项目当前版本号
  // 当项目开启 sourcemap 之后，可通过此参数在错误时直接定位到错误源码
  release: version || '',
  // 忽略非必要错误
  ignoreErrors: [
    'ApiError',
    /Unable to preload CSS fo/,
    /timeout of 30000ms exceeded/,
    /Failed to fetch dynamically imported module/
  ]
});

app.use(createPinia());
app.use(router);
initVant(app);

GTrack.init({});

const commonStore = useCommonStore();

new Promise(resolve => {
  function check() {
    if (
      window.innerWidth &&
      window.innerHeight &&
      window.screen.availWidth &&
      window.screen.availHeight
    ) {
      resolve('');
    } else {
      setTimeout(check, 10);
    }
  }
  if (['complete', 'loaded', 'interactive'].includes(document.readyState) && document.body) {
    check();
  } else {
    document.addEventListener('DOMContentLoaded', check, false);
  }
}).then(() => {
  // eslint-disable-next-line
  Promise.prototype.finally = function (callback: any) {
    return this.then(
      value => Promise.resolve(callback()).then(() => value),
      reason =>
        Promise.resolve(callback()).then(() => {
          throw reason;
        })
    );
  };
  ((doc, win) => {
    const docEle = doc.documentElement;
    const resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize';
    const recalCulate = () => {
      let width = docEle.clientWidth;

      width = width > 450 ? 450 : width;
      docEle.style.fontSize = `${50 * (width / 360)}px`;

      commonStore.$patch({
        currentWidth: width
      });
    };

    recalCulate();
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvent, recalCulate, false);
  })(document, window);
  app.mount('#app');
});
